import { environmentConfig } from 'environmentConfig';
/**
 * Dynamically injects the font-face CSS based on the current environment
 */
export const injectDynamicFont = () => {
    const { assetsBaseUrl } = environmentConfig;
    const fontUrl = `${assetsBaseUrl}/fonts/PlusJakartaSans-VariableFont_wght.ttf`;
    // Create a style element for the font-face
    const style = document.createElement('style');
    style.textContent = `
    @font-face {
      font-family: 'Plus Jakarta Sans';
      src: url('${fontUrl}') format('truetype');
      font-weight: 100 900; /* variable font axis */
      font-style: normal;
    }
  `;
    // Insert at the beginning of head to ensure it loads early
    document.head.insertBefore(style, document.head.firstChild);
};
/**
 * Dynamically sets the favicon based on the current environment
 */
export const injectFavicon = () => {
    const { assetsBaseUrl } = environmentConfig;
    const faviconUrl = `${assetsBaseUrl}/images/favicon.png`;
    // Reuse existing <link rel="icon"> if present, otherwise create a new one
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = faviconUrl;
};
/**
 * Initialize all dynamic assets
 */
export const initializeDynamicAssets = () => {
    injectDynamicFont();
    injectFavicon();
};
